import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'

const Header = styled.header`
  ${tw`flex items-center justify-center px-8 py-8 md:py-16 z-20`}
`

const PageTitleContainer = styled(Link)`
  ${tw`inline-block relative text-4xl lg:text-5xl m-0 font-serif no-underline text-black`}
`

const TitleUnderline = styled.div`
  ${tw`absolute w-full h-3`} top: 27px;
  z-index: -1;
`

const UnderlineSpan = styled.span`
  ${tw`absolute inline-block w-full`};
  height: 50%;
  ${props =>
    props.color === 'green'
      ? tw`bg-green-primary pin-t`
      : tw`bg-blue-primary pin-b`};
`

const PageHeader = () => (
  <Header>
    <PageTitleContainer to="/">
      Szczecin
      <TitleUnderline>
        <UnderlineSpan color="green" />
        <UnderlineSpan color="blue" />
      </TitleUnderline>
    </PageTitleContainer>
  </Header>
)

export default PageHeader
